
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

import vueQr from 'vue-qr'

export default {
name: "viwocertificate",
components: {XTable, vueQr, XButton, Swiper, SwiperItem},
data() {
return {
info: {},
url: '',
isImg: true,
color: false,
value: this.$route.query.seq,
setting: this.$route.query.setting,
header: {},
imgList: [],
list: [],
infoList: [],
src: ''
}
},
methods: {
showList() {
this.$router.push({name: 'viwocertificatelist'})
},
drawImg(imageUrl, item, index) {
console.log(item)
const canvas = document.getElementById("mycanvas")
const context = canvas.getContext('2d')
const img = new Image()
img.src = imageUrl

img.onload = () => {
if (img.complete) {

canvas.setAttribute("width", img.width)
canvas.setAttribute("height", img.height)


context.drawImage(img, 0, 0, img.width, img.height)

context.font = "120px Arial"
context.fillStyle = 'black'
context.textBaseline = 'top';
context.fillText(item.state === 'OK' ? item.seq : 'XXXXXXXX', 1800, 395)

context.font = "115px 宋体"
context.fillStyle = 'black'
context.textBaseline = 'top';
const str = item.state === 'OK' ? ('已通过' + item.company + '相关培训和考核，符合条件。被认证为：').split('') : ('您还没有通过北京精一强远科技有限公司考核认证，请联系您的授权单位进行审核认证为：').split('');
let company = ''
const arr = []
let maxwidth = 1760
for (let i = 0; i < str.length; i++) {
if (context.measureText(company).width < maxwidth && context.measureText(company + (str[i])).width <= maxwidth) {
company += str[i] + ' '
} else {
maxwidth = 2000
arr.push(company)
company = str[i] + ''
}
}
arr.push(company)
arr.forEach((item, index) => {
const x = index === 0 ? 480 : 240
context.fillText(item, x, 1650 + (index + 1) * 165)
})

context.font = "120px Arial"
context.fillStyle = 'black'
context.textBaseline = 'top';
context.fillText(item.state === 'OK' ? item.start + ' ~ ' + item.end : '', 700, 2970)

context.font = "300px Arial"
context.fillStyle = 'black'
context.textAlign = "center";
context.textBaseline = 'top';
context.fillText(item.name, 1240, 1200)

context.drawImage(this.$refs.vqr.getElementsByTagName('img')[index], 790, 3130, 900, 900)
const src = canvas.toDataURL('image/png')
this.imgList.push(src)
}
}
},
setCert() {
this.$http.get('api/v1/certs/set_cert_default?seq=' + this.value, this.header).then(response => {
this.$vux.alert.show({
title: '',
content: '设置成功'
})
this.$router.push({name: 'viwocertificatelist'})
}).catch(error => {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
})
},
setUsed(bol) {
this.$http.get('api/v1/certs/set_cert_used?seq=' + this.value + '&used=' + bol, this.header).then(response => {
this.$vux.alert.show({
title: '',
content: '设置成功'
})
this.$router.push({name: 'viwocertificatelist'})
}).catch(error => {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
})
},
async changeIndex(index) {
console.log(index)
}
},
created() {
const openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
this.$vux.loading.show({text: '加载中'})
this.$http.get('static/config.json').then(response => {
this.url = response.data.host;
})
this.$http.get('api/v1/wechat/' + unionid).then(async (res) => {



let account;
res.data.forEach(item => {
if (item.role === 'EXPT') {
account = item.account
}
})
let response
if (!this.value || this.setting) {
if (account) {
response = await this.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account})
this.header = {
headers: {
token: response.data.token,
opid: response.data.userid
}
}
} else {
this.$vux.loading.hide()
localStorage.setItem('viwocertificate', 'viwocertificate')
this.$router.push({name: 'vip'})
}
}
const value = this.value ? this.value : response.data.userid
const type = this.value ? 'seq' : 'userid'
if (type === 'seq') {
this.$http.get('api/v1/certs/get_cert?' + type + '=' + value).then(async response => {
this.isImg = !this.value;
const photo = await this.$http.get('api/v1/photos?path=' + response.data.signet, this.header)
this.src = 'data:image/jpeg;base64,' + photo.data.value
this.info = response.data
this.value = response.data.seq
switch (this.info.state) {
case 'OK':
this.showImg()
break;
case 'WAIT_AUDIT':
this.info.seq = '待审核'
this.color = true
break
case 'NO':
this.showImg()
this.info.seq = '待授权单位认证录入'
this.color = true
break;
case 'EXPIRED':
this.info.seq = '已过期，需重新认证'
this.color = true
this.isImg = false
break;
case 'BLACKED':
this.info.seq = '无效证书'
this.color = true
this.isImg = false
break;
}
})
this.$vux.loading.hide()
} else {
const response = await this.$http.get('/api/v1/certs/get_cert?' + type + '=' + value)
this.infoList = response.data
if (response.data !== 0) {
for (const item of this.infoList) {
const index = this.infoList.indexOf(item);
this.value = this.infoList[index].seq
this.info = this.infoList[index]
if (this.info.inuse) {
const photo = await this.$http.get('api/photos?path=' + this.info.photo, this.header)
this.drawImg('data:image/jpeg;base64,' + photo.data.value, item, index)
}
}
this.list = this.imgList
this.$vux.loading.hide()
} else {
alert('暂无证书')
}
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/certificate/viwocertificate.vue